/* import __COLOCATED_TEMPLATE__ from './escalate-if-needed.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type AppService from 'embercom/services/app-service';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    escalationRulesCount: number;
    escalationGuidanceCount: number;
    step: Fin;
    isReadOnly: boolean;
    isEcommerce?: boolean;
  };
}

export default class EscalateIfNeeded extends Component<Signature> {
  @service declare appService: AppService;

  get manageEscalationRoute() {
    if (this.appService.app.isStandaloneApp) {
      return 'apps.app.standalone.escalation';
    }

    if (this.args.isEcommerce) {
      return 'apps.app.automation.fin-ai-agent.ecommerce.escalation';
    }

    return 'apps.app.automation.fin-ai-agent.escalation';
  }

  get escalationItemsCount() {
    return this.args.escalationRulesCount + this.args.escalationGuidanceCount;
  }

  @action
  toggleEscalationDisabled() {
    this.args.step.escalationDisabled = !this.args.step.escalationDisabled;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::EscalateIfNeeded': typeof EscalateIfNeeded;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/escalate-if-needed': typeof EscalateIfNeeded;
  }
}
